define('app/views/defaultAnalytics/golf',["underscore", "jquery"], function (_, $) {
  return {
    requestTeeTimeSelection: function (teeTimes, startDate, groupCode) {
      if (teeTimes && teeTimes.TeeTime && teeTimes.TeeTime.length) {
        var course = teeTimes.CourseId;
        var locationId = app.models.golfModel.getSelectedValue("golfLocations");
        var teeTimesList = teeTimes.TeeTime;
        var uniqRatesMap = {};

        _.each(teeTimesList, function (teeTime) {
          var rates = teeTime.Rates && teeTime.Rates.Rate ? $.wrapArray(teeTime.Rates.Rate) : [];
          _.each(rates, function (rate) {
            if (!uniqRatesMap[rate.ItemId]) {
              uniqRatesMap[rate.ItemId] = rate;
            }
          });
        });

        var uniqRatesList = _.values(uniqRatesMap);
        if (uniqRatesList.length) {
          gtag("event", "view_item_list", {
            item_list_id:
              "Golf-Location-" +
              locationId +
              "Course-" +
              course +
              "-" +
              startDate,
            item_list_name: "Golf Rates on " + locationId + "-" + course,
            items: _.map(uniqRatesList, function (item) {
              return {
                item_id: item.ItemId,
                item_name: item.ItemName,
                affiliation: app.localization.siteName,
                coupon: item.groupCode ? groupCode : "",
                item_category: item.ItemCategory,
                item_category2: item.ItemSubcategory,
                item_variant: item.ItemType,
                location_id: locationId,
                price: +item.Price,
                quantity: 1,
              };
            }),
          });
        }
      }
    },
  };
});

